import { PermissionKey } from '@evimo/types/enums/permission-key';
import { AuthGuard } from '~/app/auth/guard/AuthGuard';
import { useRoleDetailPage } from './hooks/useRoleDetailPage';
import { RoleDetailPageView } from './RoleDetailPageView';

export function RoleDetailPageContainer() {
  const page = useRoleDetailPage();

  return (
    <AuthGuard requiredPermissions={[PermissionKey.ROLES_READ]}>
      <RoleDetailPageView
        organizationId={page.organizationId}
        useSystemRoleApi={page.useSystemRoleApi}
        role={page.role}
        groupedPermissions={page.groupedPermissions}
        isLoading={page.isLoading}
        error={page.error}
        canAssignPermissions={page.canAssignPermissions}
        draftPermissionKeys={page.draftPermissionKeys}
        isDirty={page.isDirty}
        isSaving={page.isSaving}
        isPermissionsUpdating={page.isPermissionsUpdating}
        isRoleEditable={page.isRoleEditable}
        isPermissionDirty={page.isPermissionDirty}
        isConfirmModalOpen={page.isConfirmModalOpen}
        isEditableSystemRole={page.isEditableSystemRole}
        onTogglePermission={page.onTogglePermission}
        onSetAllPermissions={page.onSetAllPermissions}
        allPermissionsSelected={page.allPermissionsSelected}
        onConfirmChanges={page.onConfirmChanges}
        onDiscardChanges={page.onDiscardChanges}
        onConfirmModalClose={page.onConfirmModalClose}
        onConfirmSave={page.onConfirmSave}
        onBack={page.onBack}
        userRoleName={page.userRoleName}
        canEditName={page.canEditName}
        draftName={page.draftName}
        isNameDirty={page.isNameDirty}
        isSavingName={page.isSavingName}
        onNameChange={page.onNameChange}
        onDiscardName={page.onDiscardName}
        onSaveName={() => void page.onSaveName()}
      />
    </AuthGuard>
  );
}
